import styles from "./Home.module.css";

const features = [
  { title: "ניקוז בכוח הכבידה", description: "הנוזלים מתנקזים למערכת הביוב ללא הדחה." },
  { title: "מחסום לריחות", description: "סיפון עם נוזל איטום יוצר מחסום בפני עליית ריחות." },
  { title: "תחזוקה שוטפת", description: "ניקוי רגיל והחלפת מחסנית בהתאם לעומס השימוש." },
];
const FeaturesGrid = () => (
  <section className={`${styles.section} ${styles.featuresSection}`} aria-labelledby="how-it-works-title">
    <div className={styles.container}>
      <h2 id="how-it-works-title" className={styles.sectionTitle}>איך זה עובד?</h2>
      <div className={styles.featuresGrid}>
        {features.map((feature, index) => <article key={feature.title} className={styles.featureCard}>
          <span className={styles.step} aria-hidden="true">0{index + 1}</span>
          <h3 className={styles.featureTitle}>{feature.title}</h3>
          <p className={styles.featureDescription}>{feature.description}</p>
        </article>)}
      </div>
    </div>
  </section>
);
export default FeaturesGrid;
